<template>
  <b-modal
    :visible="!!job"
    size="lg"
    centered
    hide-footer
    :title="title"
    @shown="listenKeyboard(true)"
    @hidden="listenKeyboard(false); $emit('close')"
  >
    <template v-if="job && asset">
      <div class="viewer-media-container">
        <video v-if="job.asset_type === 'video'" :key="asset.url" :src="asset.url" class="viewer-media" controls autoplay playsinline></video>
        <img v-else :key="asset.url" :src="asset.url" class="viewer-media" alt="" />

        <template v-if="has_navigation">
          <button type="button" class="viewer-arrow viewer-arrow-left" :title="$t('ia.contents.previous')" @click="navigate(-1)">
            <feather-icon icon="ChevronLeftIcon" size="22"></feather-icon>
          </button>
          <button type="button" class="viewer-arrow viewer-arrow-right" :title="$t('ia.contents.next')" @click="navigate(1)">
            <feather-icon icon="ChevronRightIcon" size="22"></feather-icon>
          </button>
        </template>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-1">
        <small class="text-muted">{{ job.model }}</small>
        <b-button variant="outline-primary" size="sm" @click="downloadFile(asset.url)">
          <feather-icon icon="DownloadIcon" class="mr-25"></feather-icon>{{ $t('ia.contents.download') }}
        </b-button>
      </div>
      <div v-if="job.final_prompt" class="mt-1">
        <h6 class="mb-50">{{ $t('ia.contents.promptUsed') }}</h6>
        <p class="viewer-prompt avenir-medium mb-0">{{ job.final_prompt }}</p>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BButton } from "bootstrap-vue";
import { downloadFile } from '@/libs/utils/others';
import { mainAsset } from './contents-utils';

export default {
  name: 'ContentViewer',
  components: {
    BModal,
    BButton,
  },
  props: {
    job: {
      type: Object,
      default: null,
    },
    // Completed jobs of the request, to move between them like a carousel
    jobs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      downloadFile,
    };
  },
  computed: {
    asset() {
      return mainAsset(this.job);
    },
    current_index() {
      return this.job ? this.jobs.findIndex((item) => item.uuid === this.job.uuid) : -1;
    },
    has_navigation() {
      return this.jobs.length > 1 && this.current_index !== -1;
    },
    title() {
      if (!this.job) return '';
      const type = this.job.asset_type === 'video' ? this.$t('ia.contents.video') : this.$t('ia.contents.image');
      return this.has_navigation ? `${type} · ${this.current_index + 1} / ${this.jobs.length}` : type;
    },
  },
  beforeDestroy() {
    this.listenKeyboard(false);
  },
  methods: {
    navigate(step) {
      if (!this.has_navigation) return;
      const index = (this.current_index + step + this.jobs.length) % this.jobs.length;
      this.$emit('navigate', this.jobs[index]);
    },
    onKeydown(event) {
      if (event.key === 'ArrowLeft') this.navigate(-1);
      else if (event.key === 'ArrowRight') this.navigate(1);
    },
    listenKeyboard(listen) {
      window.removeEventListener('keydown', this.onKeydown);
      if (listen) window.addEventListener('keydown', this.onKeydown);
    },
  },
};
</script>

<style lang="scss" scoped>
.viewer-media-container {
  position: relative;
  display: flex;
  justify-content: center;
  background-color: #f3f2f7;
  border-radius: 0.5rem;
  overflow: hidden;

  .viewer-media {
    max-width: 100%;
    max-height: 65vh;
    object-fit: contain;
  }
}
.viewer-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  color: #5e5873;
  box-shadow: 0 4px 12px rgba(34, 41, 47, 0.2);
  cursor: pointer;
  transition: background-color 200ms ease;

  &:hover {
    background-color: #fff;
    color: #7367f0;
  }
  &.viewer-arrow-left {
    left: 0.75rem;
  }
  &.viewer-arrow-right {
    right: 0.75rem;
  }
}
.viewer-prompt {
  white-space: pre-wrap;
  max-height: 160px;
  overflow-y: auto;
}
</style>
